<template>
  <div class="tech-process">
    <div class="title">
      <span class="iconLeft"></span>
      <h2>评价报告作用</h2>
      <span class="iconRight"></span>
    </div>
    <div class="content-wrapper">
      <div class="row-box">
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon1.png" />
          <div class="item-title">国家奖励</div>
          <div class="item-desc">申报国家地方及行业</div>
          <div class="item-desc">科技奖项的重要材料</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon2.png" />
          <div class="item-title">政府支持</div>
          <div class="item-desc">国务院引发的《“十三五”</div>
          <div class="item-desc">国家科技创新规划的通知》</div>
          <div class="item-desc">中第三方的评价结果作为财</div>
          <div class="item-desc">政科技经费支持的重要依据</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon3.png" />
          <div class="item-title">职称评定</div>
          <div class="item-desc">是科研人员在职称晋升时，对其</div>
          <div class="item-desc">科研能力和研发水平评定的重要依据</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon4.png" />
          <div class="item-title">结题验收</div>
          <div class="item-desc">是对科研项目研发目标的完成情况成</div>
          <div class="item-desc">果的创新和效益评判的重要依据</div>
        </div>
      </div>

      <div class="row-box">
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon5.png" />
          <div class="item-title">行业认可</div>
          <div class="item-desc">申报国家地方及行业科技</div>
          <div class="item-desc">奖项的重要材料</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon6.png" />
          <div class="item-title">价值认定</div>
          <div class="item-desc">是在获取投资、融资、认可、转让、</div>
          <div class="item-desc">合作中对成果价值评判的重要依据</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon7.png" />
          <div class="item-title">技术交易</div>
          <div class="item-desc">有力减少技术交易中买卖双方</div>
          <div class="item-desc">的沟通和谈判成本提高交易效率</div>
        </div>
        <div class="itemBox">
          <img class="imgBox" src="@/assets/images/icon8.png" />
          <div class="item-title">市场推广</div>
          <div class="item-desc">权威的专家意见和第三方</div>
          <div class="item-desc">评价报告有利于技术成果快速</div>
          <div class="item-desc">在市场推广转化和产业化</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
.tech-process {
  padding: 40px 40px; 
  background: #fff;
}

.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center; 
  margin-bottom: 60px; 

  h2 {
    font-weight: 800;
    font-size: 30px;
    color: #232323;
    line-height: 24px;
    margin: 0; 
  }
}

.iconLeft {
  width: 115px;
  height: 27px;
  margin-right: 17px;
  background-image: url('~@/assets/images/arrowBlue.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: inline-block;
}

.iconRight {
  display: inline-block;
  width: 115px;
  height: 27px;
  margin-left: 17px;
  background: url(~@/assets/images/arrowBlue.png) no-repeat center / cover;
  transform: rotateY(180deg);
}
.content-wrapper {
  width: 100%;
  margin: 0 auto; 
  max-width: 1400px;
  padding-top: 20px;
}
.row-box {
  display: flex;
  flex-wrap: wrap; 
  justify-content: space-between; 
  gap: 20px; 
  margin-bottom: 80px; 

  &:last-child {
    margin-bottom: 0; 
  }
}

.itemBox {
  position: relative;
  width: 295px;
  min-width: 260px; 
  flex: 1; 
  height: auto; 
  min-height: 255px; 
  background: linear-gradient(261deg, #FFFFFF 0%, #FFFFFF 100%);
  box-shadow: 0px 7px 35px 0px rgba(70, 106, 216, 0.22);
  border-radius: 24px;
  transition: ease-out 1s;
  text-align: center;
  padding: 0 15px 20px; 
  box-sizing: border-box; 
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 40px 0px rgba(70, 106, 216, 0.3);
  }
}

.imgBox {
  margin-top: -60px;
  max-width: 100%; 
  height: auto; 
}
.item-title {
  margin-top: -30px;
  font-weight: bold;
  font-size: 24px;
  color: #232323;
  line-height: 30px;
}
.item-desc {
  margin-top: 10px;
  font-size: 16px;
  color: #666;
  line-height: 22px;
}
@media (max-width: 1024px) {
  .title h2 {
    font-size: 26px;
  }

  .iconLeft,
  .iconRight {
    width: 80px;
    height: 20px;
  }

  .itemBox {
    max-width: 280px;
    min-height: 240px;
  }

  .item-title {
    font-size: 22px;
  }

  .item-desc {
    font-size: 15px;
  }
}
@media (max-width: 768px) {
  .title h2 {
    font-size: 22px;
  }

  .iconLeft,
  .iconRight {
    width: 60px;
    height: 18px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .row-box {
    margin-bottom: 60px;
  }

  .itemBox {
    max-width: 100%; 
    min-width: 240px;
    margin-bottom: 40px; 

    &:last-child {
      margin-bottom: 0;
    }
  }

  .imgBox {
    margin-top: -50px;
  }

  .item-title {
    font-size: 20px;
    margin-top: -25px;
  }

  .item-desc {
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .tech-process {
    padding: 30px 10px;
  }

  .title h2 {
    font-size: 20px;
  }

  .iconLeft,
  .iconRight {
    width: 50px;
    height: 15px;
  }

  .itemBox {
    min-height: 220px;
    padding: 0 10px 15px;
  }

  .imgBox {
    margin-top: -40px;
  }

  .item-title {
    font-size: 18px;
    margin-top: -20px;
  }

  .item-desc {
    font-size: 13px;
    line-height: 20px;
  }
}
</style>